import { render } from "./flashSaleAdd.vue?vue&type=template&id=033790c3&scoped=true"
import script from "./flashSaleAdd.vue?vue&type=script&lang=js"
export * from "./flashSaleAdd.vue?vue&type=script&lang=js"

import "./flashSaleAdd.vue?vue&type=style&index=0&id=033790c3&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-033790c3"]])

export default __exports__